export const enum FeatureFlags {
  // To handle market based visibility, and used mainly for LATAM market
  aprPdpFeature = 'product.aprPdpFeature',
  pdpSeoRoute = 'product.pdpSeoRoute',
  productBundleAccordion = 'product.productBundleAccordion',
  // To handle market based visibility, and used mainly for LATAM market
  showBV = 'product.showBV',
  // To handle market based visibility, and used mainly for LATAM market
  showRetailPrices = 'product.showRetailPrices',
  sopFeature = 'product.sopFeature',
  sopPdpFeature = 'product.sopPdpFeature',
  pdpProductGalleryV2 = 'product.pdpProductGalleryV2',
  sopSellableOnly = 'product.sopSellableOnly',
  addToCartEventService = 'product.addToCartEventService',
  showCheckStockStatus = 'product.showCheckStockStatus',
  showPreLaunch = 'product.showPreLaunch',
}
